import InvoicePrintPage from './InvoicePrintPage';
import InvoiceTemplateClassic from './InvoiceTemplateClassic';
import InvoiceTemplateGST from './InvoiceTemplateGST';
import { printConfigFor } from './invoiceSettingDefaults';

/**
 * Picks the print template for an invoice based on the society's per-invoice-type
 * setting, snapshotted onto the invoice as
 * `configSnapshot.invoice_setting_snapshot.invoice_template`.
 *
 *   'modern'  -> InvoicePrintPage  (existing default design)
 *   'classic' -> InvoiceTemplateClassic (Jai Ekdant style bill + receipt)
 *   'gst'     -> InvoiceTemplateGST (ZipGrid style GST tax invoice)
 *
 * Unknown / missing values fall back to 'modern' so existing invoices are
 * unaffected. Keep these keys in sync with the options in the invoice settings
 * form selector.
 */
export const INVOICE_TEMPLATE_OPTIONS = [
    { value: 'modern', label: 'Modern' },
    { value: 'classic', label: 'Classic Bill (with receipt)' },
    { value: 'gst', label: 'GST Tax Invoice' },
];

const TEMPLATES = {
    modern: InvoicePrintPage,
    classic: InvoiceTemplateClassic,
    gst: InvoiceTemplateGST,
};

const InvoiceTemplateRenderer = (props) => {
    const { invoice } = props;
    // Current template setting (falls back to the snapshot) - see printConfigFor.
    const key = printConfigFor(invoice).invoice_template;
    const Template = TEMPLATES[key] || InvoicePrintPage;
    return <Template {...props} />;
};

export default InvoiceTemplateRenderer;
